<template>
    <el-form style="margin-top:-18px">
        <el-form-item>
            <td-select
                :url="url"
                keys="sId"
                text="sName"
                :urlParam="requetParam"
                requestType="POST"
                :isPage="true"
                :placeholder="'common.PLEASE_SELECT'"
                :pageSize="selectPageSize"
                v-model="postationId"
                @change="portStationChange"
            ></td-select>
        </el-form-item>
    </el-form>
</template>
<script>
export default {
    props: {
        // 页面是否显示
        selectPageSize: {
            type: Number,
            default: function() {
                return 6;
            }
        },
        requetParam: {
            type: Object
        },
        stationId: {
            type: String,
            default: function() {
                return '';
            }
        }
    },
    computed: {},
    data() {
        return {
            loading: false,
            staffId: '',
            url: '/portStationManagerController/queryPortStationByStructureId'
        };
    },
    created() {
        this.postationId = this.stationId;
    },
    methods: {
        portStationChange(data) {
            this.$emit('portStationChange', data);
        }
    }
};
</script>
<style>
.uploadStyle {
    text-align: center;
}
</style>
